import {
  CustomFieldDefinition,
  CustomFieldDefinitionCreatePayload,
  CustomFieldDefinitionUpdatePayload,
  CompanyAllCustomFieldValues,
} from '../../companies/types';
import { api } from '../../../../core/utils/apiClient';

export class CustomFieldsService {
  async getCustomFieldDefinitions(activeOnly: boolean = true): Promise<CustomFieldDefinition[]> {
    try {
      const response = await api.get(`/api/v1/custom-fields?active_only=${activeOnly}`);
      if (response.ok) {
        return await response.json();
      }
      return [];
    } catch (error) {
      console.error('Error fetching custom field definitions:', error);
      return [];
    }
  }

  async createCustomFieldDefinition(
    payload: CustomFieldDefinitionCreatePayload
  ): Promise<CustomFieldDefinition> {
    const response = await api.post('/api/v1/custom-fields', payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async updateCustomFieldDefinition(
    id: number,
    payload: CustomFieldDefinitionUpdatePayload
  ): Promise<CustomFieldDefinition> {
    const response = await api.put(`/api/v1/custom-fields/${id}`, payload);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async deleteCustomFieldDefinition(id: number): Promise<void> {
    const response = await api.delete(`/api/v1/custom-fields/${id}`);
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.detail || `HTTP ${response.status}`);
    }
  }

  async getCompanyCustomFieldValues(
    companyId: number | string
  ): Promise<CompanyAllCustomFieldValues> {
    const response = await api.get(`/api/v1/companies/${companyId}/custom-field-values`);
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async updateCompanyCustomFieldValues(
    companyId: number | string,
    fields: Record<string, any>
  ): Promise<{ updated_fields: string[]; company_id: number }> {
    const response = await api.put(`/api/v1/companies/${companyId}/custom-field-values`, {
      fields,
    });
    if (response.ok) {
      return await response.json();
    }
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.detail || `HTTP ${response.status}`);
  }

  async deleteCompanyCustomFieldValue(
    companyId: number | string,
    fieldKey: string
  ): Promise<void> {
    const response = await api.delete(
      `/api/v1/companies/${companyId}/custom-field-values/${fieldKey}`
    );
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.detail || `HTTP ${response.status}`);
    }
  }
}

export const customFieldsService = new CustomFieldsService();
